import React, { useState } from "react";
import {
    Typography,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Select,
    MenuItem,
    CircularProgress,
    Snackbar,
    FormControl,
    InputLabel,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper
} from "@mui/material";
import Header from '../Component/Header';

const WsqPayment = () => {
    const [openModal, setOpenModal] = useState(false);
    const [saving, setSaving] = useState(false);
    const [toastOpen, setToastOpen] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [paymentType, setPaymentType] = useState("");
    const [payments, setPayments] = useState([]);

    const handleOpenModal = () => setOpenModal(true);
    const handleCloseModal = () => setOpenModal(false);
    const handleCloseToast = () => setToastOpen(false);

    const handleSavePayment = async () => {
        if (!paymentType) {
            setToastMessage("Please select a payment type");
            setToastOpen(true);
            return;
        }

        setSaving(true);
        try {
            // Simulate a save by adding to the local list (replace with API call if needed)
            setPayments((prev) => [...prev, paymentType]);
            setSaving(false);
            setOpenModal(false);
            setToastMessage("Payment saved successfully");
            setToastOpen(true);
            setPaymentType(""); // Reset selected payment type
        } catch (error) {
            setSaving(false);
            setToastMessage("Failed to save payment");
            setToastOpen(true);
        }
    };

    return (
        <div>
               <Header />
       
        <div style={{ marginTop: '24px', maxWidth: '600px', margin: 'auto', padding: '16px' }}>
            <Typography variant="h4" sx={{ fontWeight: 'bold' }}>WSQ Payment</Typography>
            <Button
                variant="contained"
                color="primary"
                sx={{ mt: 2 }}
                onClick={handleOpenModal}
            >
                Add Payment
            </Button>

            {/* Payment Selection Modal */}
            <Dialog open={openModal} onClose={handleCloseModal} fullWidth maxWidth="xs">
                <DialogTitle>Select Payment Type</DialogTitle>
                <DialogContent>
                    <FormControl fullWidth variant="outlined" sx={{ mt: 2 }}>
                        <InputLabel>Payment Type</InputLabel>
                        <Select
                            value={paymentType}
                            onChange={(e) => setPaymentType(e.target.value)}
                            label="Payment Type"
                        >
                            <MenuItem value="Cash">COD</MenuItem>
                            <MenuItem value="Credit">7 days</MenuItem>
                            <MenuItem value="Bank Transfer">15 days</MenuItem>
                            <MenuItem value="Bank Transfer">30 days</MenuItem>
                            <MenuItem value="Bank Transfer">GIRO</MenuItem>
                        </Select>
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="error" onClick={handleCloseModal} >
                        Cancel
                    </Button>
                    <Button variant="contained"  onClick={handleSavePayment} color="primary" disabled={saving}>
                        {saving ? <CircularProgress size={24} /> : "Save"}
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Table for Displaying Payment Types */}
            <TableContainer component={Paper} sx={{ mt: 3 }}>
                <Table>
                    <TableHead>
                        <TableRow>
                        <TableCell>S.No</TableCell>
                            <TableCell>Payment Type</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {payments.length > 0 ? (
                            payments.map((payment, index) => (
                                <TableRow key={index}>
                                    <TableCell></TableCell>
                                    <TableCell>{payment}</TableCell>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell colSpan={1} align="center">
                                    No payments added yet.
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

            {/* Snackbar for Save Confirmation */}
            <Snackbar
                open={toastOpen}
                message={toastMessage}
                autoHideDuration={4000}
                onClose={handleCloseToast}
            />
        </div>
        </div>
    );
};

export default WsqPayment;
